<template>
    <a-layout id="summary-layout">
        <a-layout-header id="summary-header">
        <img
            src="../../assets/user_info.png"
            class="today_img"
        >{{ $t("message")["HealthHome.pagetitle"] }}&nbsp;&nbsp;&nbsp;&nbsp;
        {{ data_date }}
        </a-layout-header>
        <a-layout-content id="summary-main">
        <a-row class="el-row">
            <a-col :span="4" class="el-col">
            <div class="grid_base">
                <div class="data_title">
                <div class="top_row">
                    <p class="blue_stick"></p>
                    <p class="card_title">{{$t("message")["HealthHome.hr"]}}</p>    
                </div>
                <img
                    :src="userHealthyShow.heart_img"
                    class="img_right"
                />
                <div class="div_left">{{userHealthyShow.heart}}
                    <span class="data_unit">bpm</span>
                </div>
                </div>
            </div>
            </a-col>
            <a-col :span="4" class="el-col">
            <div class="grid_base">
                <div class="data_title">                
                <div class="top_row">
                    <p class="blue_stick"></p>
                    <p class="card_title">{{$t("message")["HealthHome.rri"]}}</p>    
                </div>
                <img
                    :src="userHealthyShow.atrial_img"
                    class="img_right"
                >
                <div class="div_left_txt">{{userHealthyShow.atrial}}</div>
                </div>
            </div>
            </a-col>
            <a-col :span="4" class="el-col">
            <div class="grid_base">
                <div class="data_title">
                <div class="top_row">
                    <p class="blue_stick"></p>
                    <p class="card_title">{{$t("message")["HealthHome.step"]}}</p>    
                </div>
                <img
                    :src="userHealthyShow.step_img"
                    class="img_right"
                >
                <div class="div_left">{{userHealthyShow.step}}</div>
                </div>
            </div>
            </a-col>
            <a-col :span="4" class="el-col">
            <div class="grid_base">
                <div class="data_title">
                <div class="top_row">
                    <p class="blue_stick"></p>
                    <p class="card_title">{{$t("message")["HealthHome.sleep"]}}</p>    
                </div>
                <img
                    :src="userHealthyShow.sleep_img"
                    class="img_right"
                >
                <div class="div_left">{{userHealthyShow.sleepHour}}
                    <span class="data_unit_two">{{$t("message")["HealthHome.hours"]}}</span>
                    {{userHealthyShow.sleepMin}}
                    <span class="data_unit">{{$t("message")["HealthHome.minutes"]}}</span>
                </div>
                </div>
            </div>
            </a-col>
            <a-col :span="4" class="el-col">
            <div class="grid_base">
                <div class="data_title">
                <div class="top_row">
                    <p class="blue_stick"></p>
                    <p class="card_title">{{$t("message")["HealthHome.ecg"]}}</p>    
                </div>
                <img
                    :src="userHealthyShow.ecg_img"
                    class="img_right"
                >
                <div class="div_left_txt">{{userHealthyShow.ecg}}</div>
                </div>
            </div>
            </a-col>
        </a-row>
        <div id="pos_div">
            <img src="../../assets/user_info.png" class="info_logo"/>
            {{$t("message")["HealthHome.position"]}}
        </div>
        <div id="healthyMap"
            class="healthy_map">
        </div>
        </a-layout-content>
    </a-layout>
  
</template>

<script>
const moment = require('moment');
import request from "../../utils/request";
import domain from "../../domain";
export default {
    data() {
    return {
        amap: null,
        device_type: 1,
        uid: "",
        deviceid: "",
        data_date: "",         
        userHealthyShow: {
            heart: "--",
            heart_type: true,
            heart_img: require("../../assets/heart_normal.png"),
            atrial: "--",
            atrial_type: false,
            atrial_img: require("../../assets/atrial_normal.png"),
            step: "--",
            step_type: true,
            step_img: require("../../assets/step_normal.png"),
            sleepHour: "--",
            sleepMin: "--",
            sleep_type: true,
            sleep_img: require("../../assets/sleep_normal.png"),
            ecg: "--",
            ecg_type: true,
            ecg_img: require("../../assets/ecg_normal.png")
        },
        location:{
            longitude: 109.707965,
            latitude: 18.253899,
            record_time: ''
        }
    };
    },
    methods: {
        createMaps: function(hasData) {
            if(!this.amap){
                console.log('created map');
                var map = new BMapGL.Map("healthyMap");
                this.amap = map;
            }
            
            if(hasData){
                var convertor = new BMapGL.Convertor();
                var pointArr = [];
                var original = new BMapGL.Point(this.location.longitude, this.location.latitude);
                pointArr.push(original);
                convertor.translate(pointArr, COORDINATES_WGS84, COORDINATES_BD09, this.translateCallback);
            } else{
                console.log('nodata');
                this.amap.clearLabels();
                this.amap.clearOverlays();
                this.amap.clearSpots();
                var myGeo = new BMapGL.Geocoder();
                let that = this;
                myGeo.getPoint('深圳市福田区', function(point){
                    if(point){
                        that.amap.centerAndZoom(point, 14);
                    }else{
                        alert('您选择的地址没有解析到结果！');
                    }
                }, '深圳市')
            }
            var zoomCtrl = new BMapGL.ZoomControl();
            this.amap.addControl(zoomCtrl);
            var scaleCtrl = new BMapGL.ScaleControl();
            this.amap.addControl(scaleCtrl);
        },

        translateCallback(data){
            if(data.status != 0){
                return;
            }
            var point = data.points[0];
            this.amap.centerAndZoom(point, 14);
            var myIcon = new BMapGL.Icon("http://api8.iwown.com/dist/snapshot/marker.png", new BMapGL.Size(14, 18),{
                anchor: new BMapGL.Size(7, 9)
            });
            let marker = new BMapGL.Marker(point);
            marker.setIcon(myIcon);
            this.amap.addOverlay(marker);
            let content = this.location.record_time;
            var label = new BMapGL.Label(content, {  
                position: point,                         
                offset: new BMapGL.Size(10, 10)
            });
            this.amap.addOverlay(label);
            label.setStyle({ 
                    color: '#2284FF',
                    fontSize: '12px',
                    border: '1px solid #2284FF',
                    borderRadius: '5px'
                })            
        },

        getAtrialType: function(deviceid, data_date) {
            let that = this;
            let reqParams = {
                deviceid: deviceid,
                recordate: data_date
            };
            let reqUrl = domain.URLS.afLatest;
            if(this.device_type == 2){
                reqParams={
                  uid: this.uid,
                  recordate: data_date
                };
                reqUrl = domain.URLS.afBleLatest;
            }            
            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            })
            .then(function(response) {
                if (response != null) {
                    let sd = response.data;
                    if (response.data.ReturnCode == 0) {
                        let result = response.data.Data;
                        if (result == 0 || result == -1000) {
                            that.userHealthyShow.atrial = "正常";
                            that.userHealthyShow.atrial_type = true;
                            that.userHealthyShow.atrial_img = require("../../assets/atrial_normal.png");
                        } else {
                            that.userHealthyShow.atrial = "异常";
                            that.userHealthyShow.atrial_type = false;
                            that.userHealthyShow.atrial_img = require("../../assets/atrial_normal.png");
                        }
                    }
                    else{
                        that.userHealthyShow.atrial = "--";
                        that.userHealthyShow.atrial_type = true;
                        that.userHealthyShow.atrial_img = require("../../assets/atrial_normal.png");              
                    }
                }
            })
            .catch(function(error) {
                if (error != null) {
                    console.log(error);
                }
            });
        },

        //向父组件传递数据
        sendParent: function(onlineTime){
            console.log("向父控件传递数据-------");
            let childEvent = {
                step: this.userHealthyShow.step,
                online: onlineTime
            };
            this.$emit("childEvent",childEvent)
        },

        displayStepData(step) {
            this.userHealthyShow.step = step;
            this.userHealthyShow.step_type = true;
            this.userHealthyShow.step_img = require("../../assets/step_normal.png");
        },

        getHrData(deviceid, data_date){
            let momentDate = moment(data_date);
            let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
            let that = this;
            let reqParams = {
                device_id: deviceid,
                start_date: data_date,
                end_date: next_date
            };
            let reqUrl = domain.URLS.hrdataUrl;
            if(this.device_type == 2){
                reqParams={
                  uid: this.uid,
                  record_date: data_date
                };
                reqUrl = domain.URLS.hrBledataUrl;
            }
            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            })
            .then(function(response) {
                if (response != null) {
                let retCode = response.data.ReturnCode;
                if(retCode == 0){
                    let dataList = response.data.Data;
                    let mHeart = dataList[dataList.length-1].avg_bpm;
                    if(mHeart>0){
                        that.userHealthyShow.heart = mHeart;
                    }
                    if (mHeart > 170) {
                        that.userHealthyShow.heart_type = false;
                        that.userHealthyShow.heart_img = require("../../assets/heart_normal.png");
                    } else {
                        that.userHealthyShow.heart_type = true;
                        that.userHealthyShow.heart_img = require("../../assets/heart_normal.png");
                    }
                }
                }
            })
            .catch(function(error) {
                if (error != null) {
                console.log(error);
                }
            });
        },

        getSleepData(deviceid,data_date){
            let momentDate = moment(data_date);
            let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
            let that = this;
            let reqParams = {
                device_id: deviceid,
                start_date: data_date,
                end_date: next_date
            };
            let reqUrl = domain.URLS.sleepDataUrl;
            if(this.device_type == 2){
                momentDate = moment(data_date);
                let prev_date = momentDate.subtract(1, 'day').format('YYYY-MM-DD')
                reqParams={
                  uid: this.uid,
                  start_date: prev_date,
                  end_date: data_date
                };
                reqUrl = domain.URLS.sleepBleDataUrl;
            }

            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            })
            .then(function(response) {
                if (response != null) {
                let retCode = response.data.ReturnCode;
                if(retCode == 0){
                    let dataList = response.data.Data;
                    let sleep = dataList[0].deep_sleep+dataList[0].light_sleep+dataList[0].weak_sleep+dataList[0].eyemove_sleep;
                    that.userHealthyShow.sleepHour = parseInt(sleep / 60);
                    that.userHealthyShow.sleepMin = sleep % 60;
                    if (sleep < 300 || sleep > 960) {
                        that.userHealthyShow.sleep_type = false;
                        that.userHealthyShow.sleep_img = require("../../assets/sleep_normal.png");
                    } else {
                        that.userHealthyShow.sleep_type = true;
                        that.userHealthyShow.sleep_img = require("../../assets/sleep_normal.png");
                    }
                }
                }
            })
            .catch(function(error) {
                if (error != null) {
                console.log(error);
                }
            });
        },

        getGnssData(deviceid,data_date){
            let momentDate = moment(data_date);
            let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
            let that = this;
            request({
                url: domain.URLS.gnssDataUrl,
                methods: "GET",
                params: {
                device_id: deviceid,
                start_date: data_date,
                end_date: next_date
                }
            })
            .then(function(response) {
                if (response != null) {
                let retCode = response.data.ReturnCode;
                
                if(retCode == 0){
                    let dataList = response.data.Data;
                    let longitude = dataList[dataList.length-1].longitude;
                    let latitude = dataList[dataList.length-1].latitude;
                    let record_time = dataList[dataList.length-1].record_time;
                    that.sendParent(record_time);
                    that.location.longitude = longitude;
                    that.location.latitude = latitude;
                    that.location.record_time = record_time;
                    console.log("获取的地理位置: ",longitude,latitude);
                    that.createMaps(true);
                }else{
                    console.log(response.data);
                    that.createMaps(false);
                }
                }
            })
            .catch(function(error) {
                if (error != null) {
                console.log(error);
                }
            });
        },
        
        getEcgAiResult(deviceid,data_date){
            let momentDate = moment(data_date);
            let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
            let that = this;
            let reqParams = {
                device_id: deviceid,
                start_date: data_date,
                end_date: next_date
            };
            let reqUrl = domain.URLS.ecgAIUrl;
            if(this.device_type == 2){
                reqParams={
                  uid: this.uid,
                  start_date: data_date,
                  end_date: next_date
                };
                reqUrl = domain.URLS.ecgBleAIUrl;
            }

            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            })
            .then(function(response) {
                if (response != null) {
                    let retCode = response.data.ReturnCode;
                    if(retCode == 0){
                        let dataList = response.data.Data;
                        let ai_result = dataList[dataList.length-1].result;
                        if(ai_result=='SN'){
                            that.userHealthyShow.ecg = '窦性心律';
                            that.userHealthyShow.ecg_type = false;
                            that.userHealthyShow.ecg_img = require("../../assets/ecg_normal.png");
                        } else if(ai_result=='SNB'){
                            that.userHealthyShow.ecg = '窦性心律过缓';
                            that.userHealthyShow.ecg_type = false;
                            that.userHealthyShow.ecg_img = require("../../assets/ecg_normal.png");
                        } else if(ai_result=='SNT'){
                            that.userHealthyShow.ecg = '窦性心律过速';
                            that.userHealthyShow.ecg_type = false;
                            that.userHealthyShow.ecg_img = require("../../assets/ecg_normal.png");
                        } else if(ai_result=='SNA'){
                            that.userHealthyShow.ecg = '窦性心律不齐';
                            that.userHealthyShow.ecg_type = false;
                            that.userHealthyShow.ecg_img = require("../../assets/ecg_normal.png");
                        } else{
                            that.userHealthyShow.ecg = "正常";
                            that.userHealthyShow.ecg_type = true;
                            that.userHealthyShow.ecg_img = require("../../assets/ecg_normal.png");              
                        }
                    }
                }
            })
            .catch(function(error) {
                if (error != null) {
                console.log(error);
                }
            });
        },     
    },

    mounted: function() {
        this.device_type = sessionStorage.getItem("device_type");
        this.deviceid = sessionStorage.getItem("deviceid");
        if(this.device_type==2){
            this.uid = sessionStorage.getItem("uid");
        }

        let step = this.$route.params.step;
        this.data_date = this.$route.params.data_date;

        //this.createMaps(false);
        this.getGnssData(this.deviceid,this.data_date);
        this.displayStepData(step);
        this.getHrData(this.deviceid,this.data_date);
        this.getSleepData(this.deviceid,this.data_date);
        this.getEcgAiResult(this.deviceid,this.data_date);
        this.getAtrialType(this.deviceid,this.data_date);
    }
};
</script>

<style scoped>
#summary-layout {
    flex: 1;
}

#summary-header {
    padding-top: 5px;
    height: 50px;
    font-size: 16px;
    color: #2284FF;
    letter-spacing: 0;
    line-height: 50px;
    font-weight: bold;
    background-color: #ffffff;
    padding-left: 15px;
}

#summary-main {
    background-color: #ffffff;
}

.el-row {
    margin-bottom: 20px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.el-col {
    flex: 1;
    border-radius: 4px;
    width: 200px;
    padding: 10px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple-light {
    background: #e5e9f2;
}

.row-bg {
    padding: 10px;
    background-color: #f9fafc;
}

.grid_base {
    border-radius: 4px;
    height: 70px;
    color: #ffffff;
    display: flex;
    box-shadow: 0 0 10px rgba(1, 24, 54, 0.1);
}

.grid_green {
    background: linear-gradient(to right, #7bbfad, #b4e5d7);
}

.grid_red {
    background: linear-gradient(to right, #ff5da1, #ffab68);
}

.div_center {
    height: 30px;
    line-height: 30px;
}

.today_img {
    width: 13px;
    height: 20px;
    margin-top: 0px;
    margin-bottom: 2px;
    vertical-align: middle;
    margin-right: 10px;
}

.data_title {
    font-size: 14px;
    color: #606165;
    padding: 6px 10px 5px 10px;
    width: 100%;
    position: relative;
}

.top_row {
    display: flex;
    align-items: center;
}

.blue_stick {
    background-color: #2284FF;
    width: 4px;
    height: 16px;
    margin-right: 10px;
}

.card_title {
    font-size: 13px;
    color: #606165;
}

.img_right {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 10px;
    bottom: 6px;
}

.div_left {
    font-family: Anton-Regular;
    font-size: 20px;
    position: absolute;
    bottom: 5px;
}

.div_left_txt {
    font-family: Anton-Regular;
    font-size: 18px;
    position: absolute;
    bottom: 6px;
    font-weight: bold;
}

.data_unit {
    margin-left: -2px;
    font-size: 12px;
}

.data_unit_two {
    margin-left: -2px;
    font-size: 12px;
    margin-right: -2px;
}

#pos_div {
    margin-left: 15px;
    font-size: 16px;
    color: #2284FF;
    font-weight: bold;
}

.healthy_map {
    width: calc(100% - 20px); 
    height: 500px;
    background: #ffffff;
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: none;
    float: left;
}

.info_logo {
    width: 13px;
    height: 20px;
    margin-right: 10px;
}
</style>
